import { defineMessages } from "react-intl";

import {
	iggMessages,
	validator
} from "lib/build/forms/ltx/phase-i/viral-serology/hsv2Serology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hsv2Serology: {
		id: "form.hsv2_serology",
		defaultMessage: "HSV2"
	},
	igg: {
		id: "form.hsv2_serology.igg",
		defaultMessage: "IgG"
	}
});

const fields: { [key: string]: FieldData } = {
	igg: {
		type: "field",
		path: ["igg"],
		label: messages.igg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: iggMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.igg }] }]
};

export const node: LeafNode = {
	id: "hsv2Serology",
	value: {
		title: messages.hsv2Serology,
		validator,
		fieldset,
		isImportant: true
	}
};
